import { render, staticRenderFns } from "./HorseSearchInput.vue?vue&type=template&id=9a95990c&scoped=true"
import script from "./HorseSearchInput.vue?vue&type=script&lang=ts"
export * from "./HorseSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a95990c",
  null
  
)

export default component.exports